import { Icon } from "@material-ui/core";
import styled from "styled-components";

export const StyledFoldersSection = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow: hidden;
`;

export const SideBarItem = styled.div`
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    color: #444;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    flex-shrink: 0;
    height: 30px;
    line-height: 16px;
    min-height: 30px;
    overflow: hidden;
    padding: 4px 8px;
    transition: background-color 300ms;
    cursor: pointer;
    border-radius: 2px;

    & > .material-icons {
        font-size: 18px;
        margin-right: 8px;
        color: #888;
        font-variation-settings: "FILL" 0;
    }

    &:hover:not(.selected),
    &.hover:not(.selected) {
        background: #eee;

        & > .material-icons {
            color: #11a9e2;
        }
    }

    &.selected {
        cursor: default;
        background: #e9e9e9;

        & > .material-icons {
            color: #11a9e2;
        }
    }

    .folder-name {
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const SideBarLabel = styled.div`
    box-sizing: border-box;
    width: 100%;
    flex-shrink: 0;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    color: #888;
    height: 30px;
    min-height: 30px;

    & > *:nth-child(2) {
        margin-left: auto;
    }
`;

export const FolderContainer = styled.div`
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
`;

export const LibraryFolder = styled(SideBarItem)<{ $nested?: boolean }>`
    padding: ${({ $nested }) => $nested ? "4px 8px 4px 28px" : "4px 8px"};

    .folder-name {
        flex: 1;
        line-height: 16px;
        min-width: 0;
        white-space: nowrap;
    }

    .MuiIconButton-root {
        padding: 0;
        opacity: 0;
        min-width: 0;
        width: 0;
        height: 18px;
        margin-left: auto;

        .MuiIcon-root,
        .bai-icon {
            color: #888 !important;
            font-size: 18px !important;
            width: 18px !important;
            height: 18px !important;
            line-height: 1 !important;
        }

        &:hover {
            .MuiIcon-root,
            .bai-icon {
                color: #555 !important;
            }
        }
    }

    &:hover,
    &.hover {
        .folder-toggle-icon > .material-icons {
            color: #11a9e2;
        }

        .folder-toggle-icon.has-subfolders {
            .folder-icon {
                opacity: 0;
            }

            .expand-arrow {
                opacity: 1;
            }
        }

        .MuiIconButton-root {
            opacity: 1;
            width: 18px;
        }
    }

    .folder-toggle-icon {
        position: relative;
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        margin-right: 8px;

        & > .material-icons {
            position: absolute;
            inset: 0;
            font-size: 18px;
            color: #888;
            font-variation-settings: "FILL" 0;
        }

        .expand-arrow {
            opacity: 0;
        }
    }

    &.selected .folder-toggle-icon > .material-icons {
        color: #11a9e2;
    }
`;

export const StyledAddIcon = styled(Icon).attrs({ className: "material-symbols-outlined" })`
    &&& {
        color: #888 !important;
        font-size: 16px !important;
        height: 16px !important;
        line-height: 1 !important;
        width: 16px !important;
    }
`;

export function selectedClass(selected: boolean): string {
    return selected ? "selected" : "";
}

const DEFAULT_WORKSPACE_RESOURCES_SIDEBAR_WIDTH = 200;

const WORKSPACE_RESOURCES_SIDEBAR_WIDTH_STORAGE_KEY = "bai-team-library-folder-sidebar-width";

export function getWorkspaceResourcesSidebarWidth(): number {
    const saved = parseInt(localStorage.getItem(WORKSPACE_RESOURCES_SIDEBAR_WIDTH_STORAGE_KEY) ?? "", 10);
    if (Number.isFinite(saved)) {
        return saved;
    }

    return DEFAULT_WORKSPACE_RESOURCES_SIDEBAR_WIDTH;
}

export function saveWorkspaceResourcesSidebarWidth(width: number): void {
    localStorage.setItem(WORKSPACE_RESOURCES_SIDEBAR_WIDTH_STORAGE_KEY, String(width));
}
